<template>
  <div id="container" style="width: 100%; height: 500px;"></div>
</template>

<script>
import { onMounted } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  setup() {
    onMounted(() => {
      AMapLoader.load({
        key: "42996bac22de47b7bf8ed4ad0b4370ff",
        version: "2.0",
        plugins: ["AMap.Geocoder"], // 需要用的插件，比如 Geocoder
      })
          .then((AMap) => {
            const map = new AMap.Map("container", {
              center: [116.397428, 39.90923], // 北京坐标
              zoom: 11,
            });
          })
          .catch((e) => {
            console.error("高德地图加载失败", e);
          });
    });
  },
};
</script>
